import { ref, computed } from 'vue'
import thTranslations from '../locales/th.json'
import enTranslations from '../locales/en.json'

const currentLanguage = ref(localStorage.getItem('language') || 'th')

const translations = {
  th: thTranslations,
  en: enTranslations
}

export function useI18n() {
  const t = (key) => {
    const keys = key.split('.')
    let value = translations[currentLanguage.value]
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k]
      } else {
        // Fallback to English if key not found in current language
        value = translations.en
        for (const fallbackKey of keys) {
          if (value && value[fallbackKey]) {
            value = value[fallbackKey]
          } else {
            return key // Return key if not found
          }
        }
        break
      }
    }
    
    return value || key
  }

  const setLanguage = (lang) => {
    if (translations[lang]) {
      currentLanguage.value = lang
      localStorage.setItem('language', lang)
    }
  }

  const currentLang = computed(() => currentLanguage.value)

  return {
    t,
    setLanguage,
    currentLang
  }
}